<template>
  <div>hom
    <a href='#/login'>tttttttttt</a>
    e</div>
</template>

<script>
  export default {
    name: 'index',
    mounted () {
    }
  };
</script>
